
<div>
    <app-bar :title="t('club_products_title')">
        <template #actions>
            <div class="px-10">
                <v-btn
                    v-if="permitted('admin_club_management')"
                    :to="{ name: 'club-products.create' }"
                    class="sm sm-h"
                    color="orange"
                >{{ t('club_product_title_add') }}</v-btn>
            </div>
        </template>
    </app-bar>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <card-collection
            :meta="meta"
            :busy="overlay"
            @updated="updated"
        >
            <template #filters>
                <v-toolbar
                    elevation="0"
                    color="transparent"
                    class="mt-7"
                    height="56"
                >
                    <v-text-field
                        v-model="queries.search"
                        @click:clear="clear"
                        class="input-search md mr-2"
                        clearable
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        :label="t('general_label_search')"
                    ></v-text-field>

                    <v-btn
                        @click="search"
                        class="sm mx-5"
                        color="primary"
                    >{{ t('general_action_search') }}</v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        v-ripple="false"
                        plain
                        color="orange darken-4"
                        @click="reset"
                    >{{ t('general_action_reset_filters') }}</v-btn>
                </v-toolbar>
            </template>

            <template #data>
                <thead>
                <tr>
                    <th class="touched">
                        <sort-field
                            v-model="queries.sort"
                            field="id"
                            @touched="onSort"
                        >{{ t('club_product_label_id') }}
                        </sort-field>
                    </th>
                    <th>
                        <sort-field
                            v-model="queries.sort"
                            field="name"
                            @touched="onSort"
                        >{{ t('club_product_label_name') }}
                        </sort-field>
                    </th>
                    <th>{{ t('club_product_label_manufacturer') }}</th>
                    <th>{{ t('general_action_published') }}</th>
                    <th class="text-center">{{ t('general_label_action') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="collection.data.length === 0">
                    <td class="text-center" colspan="5">{{ t('general_text_no_data') }}</td>
                </tr>
                <template v-else v-for="item in collection.data">
                    <tr>
                        <td>
                            <a
                                :href="`/club-products/${item.id}/view`"
                                @click.prevent="touch(item)"
                                :class="{ 'orange--text': ! item.enabled }"
                            >{{ item.id }}</a>
                        </td>
                        <td>
                            <a
                                :href="`/club-products/${item.id}/view`"
                                @click.prevent="touch(item)"
                            >{{ item.name }}</a>
                        </td>
                        <td>{{ item.manufacturer }}</td>
                        <td>{{ item.enabled ? t('general_text_yes') : t('general_text_no') }}</td>
                        <td class="text-center">
                            <v-menu
                                offset-y
                                left
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item
                                        v-if="permitted('admin_club_management')"
                                        @click.prevent="edit(item)"
                                    >
                                        <v-list-item-title
                                            class="customized-deep-primary--text"
                                        >{{ t('general_action_edit') }}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="permitted('admin_club_management')"
                                        @click.prevent="suspend(item)"
                                    >
                                        <v-list-item-title
                                            v-if="item.enabled"
                                            class="customized-deep-primary--text"
                                        >{{ t('general_action_suspend') }}
                                        </v-list-item-title>
                                        <v-list-item-title
                                            v-else
                                            class="orange--text"
                                        >{{ t('general_action_unsuspend') }}
                                        </v-list-item-title>
                                    </v-list-item>
                                    <confirm-modal
                                        v-if="permitted('admin_club_management')"
                                        :title="t('general_title_confirm_action')"
                                        @agree="del(item)"
                                    >
                                        <template #default="{ on, attrs }">
                                            <v-list-item
                                                href
                                                v-on="on"
                                                v-bind="attrs"
                                            >
                                                <v-list-item-title
                                                    class="customized-deep-primary--text"
                                                >{{ t('general_action_delete') }}</v-list-item-title>
                                            </v-list-item>
                                        </template>
                                    </confirm-modal>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
                </tbody>
            </template>
        </card-collection>
    </v-layout>
</div>
